import { createAsyncThunk } from '@reduxjs/toolkit'
import ApplicationConf from 'conf/ApplicationConf'
import LogAction from 'log/actions/LogAction'
import i18n from 'simple-react-i18n'
import { REJECTED, IDLE } from 'store/DataManagerConstants'
import ToastrAction from 'toastr/actions/ToastrAction'
import { genericPromise } from 'utils/ActionUtils'

const ContributorThunk = {
    fetchContributors: createAsyncThunk(
        'fetchContributors',
        async (_, { rejectWithValue, dispatch }) => {
            try {
                const response = await genericPromise(ApplicationConf.referencial.contributors(), 'GET')
                return response
            } catch (err) {
                dispatch(LogAction.logError(`${i18n.fetchError} ${i18n.contributors} : ${err}`))
                dispatch(ToastrAction.error(`${i18n.fetchError} ${i18n.contributors}`))
                return rejectWithValue(err)
            }
        },
        {
            condition: (arg = { forceFetch: false }, { getState }) => {
                const state = getState()
                const { contributorsStatus } = state.DataManagerReducer.contributor
                if (arg.forceFetch) {
                    return contributorsStatus !== REJECTED
                }
                return contributorsStatus === IDLE
            },
        },
    ),
}

export default ContributorThunk